
    import React from 'react';
    import SpriteSymbol from "svg-baker-runtime/browser-symbol";
    import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
    import SpriteSymbolComponent from "../src/Icon.js";
    
    const symbol = new SpriteSymbol({
  "id": "vvi",
  "use": "vvi-usage",
  "viewBox": "0 0 91.333 85.167",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 91.333 85.167\" id=\"vvi\"><g fill=\"none\"><circle cx=\"56.004\" cy=\"27.065\" r=\"4.007\" /><circle cx=\"28.009\" cy=\"41.684\" r=\"4.007\" /><path d=\"M39.392 37.434l-10.244 3.787M55.083 27.757l-5.261 3.964\" /><circle cx=\"45.03\" cy=\"35.347\" r=\"6.011\" /><path d=\"M47.359 38.038l6.599 7.337\" /><circle cx=\"59.317\" cy=\"51.333\" r=\"8.015\" /><path d=\"M40.375 25.031l3.046 6.864\" /><circle cx=\"37.12\" cy=\"17.706\" r=\"8.014\" /></g></symbol>"
});
    sprite.add(symbol);

    export default class VviSpriteSymbolComponent extends React.Component {
      render() {
        return <SpriteSymbolComponent glyph="vvi" {...this.props} />;
      }
    }
  